<template>
  <section class="section-container">
    <v-row class="sign_in">
      <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" md="6" class="left pa-0">
        <v-img height="100%" max-width="1000" :src="require(`@/assets/images/driver_login.png`)">
          <v-col>
            <div class="fill-width text-center white--text" style="position: absolute;top: 45%;">
              <h1>
                DXE Station Admin
              </h1>
            </div>
          </v-col>
        </v-img>
      </v-col>
      <v-col cols="12" md="6" class="right" :class="$vuetify.breakpoint.smAndDown ? 'background-image' : ''">
        <div style="position: relative;width: 100%;top: 15%;">
          <div style="position: absolute;width: 100%;">
            <v-layout justify-center>
              <v-img max-height="300" max-width="300" contain :src="require(`@/assets/images/DXEstation_logo_RGB.png`)" />
            </v-layout>
            <h2>Admin Login</h2>
            <validation-observer ref="observer">
              <v-form @submit.prevent="loginButtonClickEvent">
                <v-row>
                  <v-col cols="12" md="10" offset-md="1">
                    <v-card class="rounded-card" style="padding: 20px">
                      <v-card-title></v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <validation-provider v-slot="{ errors }" name="ログインID" rules="required">
                              <v-text-field
                                v-model="loginId"
                                :error-messages="errors"
                                label="ログインID"
                                name="loginId"
                                hide-details="auto"
                                outlined
                                persistent-placeholder
                              >
                                <template v-slot:label>
                                  <v-icon small>
                                    mdi-email-outline
                                  </v-icon>&nbsp;ログインID
                                </template>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <validation-provider v-slot="{ errors }" name="パスワード" rules="required">
                              <v-text-field
                                v-model="password"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :error-messages="errors"
                                :type="showPassword ? 'text' : 'password'" label="パスワード"
                                name="password"
                                outlined
                                persistent-placeholder
                                @click:append="showPassword = !showPassword"
                              >
                                <template v-slot:label>
                                  <v-icon small>
                                    mdi-lock-outline
                                  </v-icon>&nbsp;パスワード
                                </template>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn type="submit" color="primary" block large elevation="4">
                          ログイン
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </validation-observer>
          </div>
        </div>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'AdminSessionIndex',
  components: {
  },
  mixins: [
  ],
  data() {
    return {
      loginId: null,
      password: null,
      showPassword: false,
    }
  },
  created() {
    this.signOut()
  },
  methods: {
    ...mapActions('AdminAuthentication', {
      signIn: 'signInAdmin',
      signOut: 'signOutAdmin'
    }),
    loginButtonClickEvent() {
      const params = {
        login_id: this.loginId,
        password: this.password,
      }

      this.signIn({ params: params }).then(() => {
        let pushParams = {}
        if ('backuri' in this.$route.query && this.$route.query.backuri.match(/^\//)) {
          pushParams['path'] = this.$route.query.backuri
        } else {
          pushParams['name'] = 'AdminContractors'
        }
        pushParams['params'] = { resetPagination: true, resetCondition: true }
        this.$router.push(pushParams, () => { })
      })
    }
  }

}
</script>

<style scoped lang="scss">
.container {
  padding: 0 !important;
}

.background-image {
  background-image: linear-gradient(to right top, #2d61aa, #1b77b9, #118cc6, #23a1cf, #3fb5d7);
  background-size: cover;
}

.section-container {
  background: #fafafa;

  .sign_in {
    height: 93vh;

    .left {
      background-image: linear-gradient(to right top, #3475b5, #2b80bc, #248ac2, #2095c7, #239fcb);
    }

    .right {
      h2 {
        text-align: center;
        margin: 10px 40px 40px 40px;
      }
    }
  }
}
</style>
